import {useDispatch, useSelector} from 'react-redux'
import {setPersonaPercentage as setPersonaPercentageAction, selectPersonaPercentage} from '../slices/personaQuerySlice'

export const usePersonaQuery = () => {
  const dispatch = useDispatch()

  const personaPercentage = useSelector(selectPersonaPercentage)

  // Return the same API as the original provider
  return {
    personaPercentage,
    setPersonaPercentage: (value) => dispatch(setPersonaPercentageAction(value))
  }
}
